import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { API } from 'src/Services/Api/Api';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { UserStore } from 'src/Stores/User/UserStore';
import Auth from '../../Services/Auth';
import Message from '../Messaging/Message';
import './Login.scss';




const auth = new Auth();

@inject('stores')
@observer
class Login extends React.Component {
    public props: any;
    public state = {
        authenticated: false,
        displayForgotModal: false,
        empty: false,
        forgotEmail: '',
        incorrect: false,
        password: '',
        updateDate: '',
        updateVersion: '',
        userName: '',

    };
    public MessageStore: any;
    public UserStore: UserStore;
    private TenantStore: TenantStore;
    private api: API;
    constructor(props: any) {
        super(props);
        this.api = this.props.stores.Api;
        this.UserStore = this.props.stores.UserStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.onDismissAlert = this.onDismissAlert.bind(this);
    }

    public componentDidMount() {
        fetch('/assets/update_data.json')
            .then(data => data.json())
            .then(updateData => {
                const updateDate = updateData.UpdateDate;
                const updateVersion = updateData.Version;
                this.setState({
                    updateDate,
                    updateVersion,
                });
            });
    }

    public handleInputChange(event: any) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    public handleLogin(event: any) {
        event.preventDefault();

        this.api.login(
            '/account/login',
            {
                password: this.state.password,
                userName: this.state.userName,
            }
        )
            .then(
                (data: any) => {
                if (data) {
                    const offline = this.props.stores.SyncStore.offline;
                    
                    if ( data.token ) {
                        auth.setToken(data.token);
                    }
                    this.MessageStore.removeAllMessages();
                    this.UserStore.getProfile().
                    then(() => {

                        // if (offline) {
                        //     const unparsedRoles = localStorage.getItem('roles');
                        //     if (unparsedRoles) {
                        //         const roles = JSON.parse(unparsedRoles);
                        //         if (Array.isArray(roles) && roles.indexOf('Admin') >= 0) {
                        //             const message = "The last user that logged in online was an admin user so offline functionality is not enabled.";
                        //             const message2 = "Please log out and log in online as a Mud Engineer / Senior Mud Engineer / Field Supervisor so that you can access Wells and Well Tests.";
                        //             this.MessageStore.addMessage(message, 'danger');
                        //             this.MessageStore.addMessage(message2, 'danger');
                        //         }

                        //     }
                        // }
                        if ( data.roles && !offline ) {
                            localStorage.setItem('roles', JSON.stringify(data.roles));
                        }
                        
                        localStorage.setItem('userName', this.state.userName);
                        if (!offline) {
                            this.props.stores.getAllDataForOffline();
                            this.props.stores.setSyncLoginFailed(false);
                        }
                        this.props.history.push('/home');
                    });
                
                    
                }
            }).catch(
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public onDismissAlert() {
        this.setState({
            empty: false,
            incorrect:false
        });
    }

    private toggleForgotModal = () => {
        this.setState({
            displayForgotModal: !this.state.displayForgotModal
        });
    }

    private updateForgotEmail = (event:any) => {
        this.setState({
            forgotEmail: event.target.value,
        });
    }

    private isForgotValidEmail = () => {
        if(this.state.forgotEmail === '')
        {
            return false;
        }

        return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(this.state.forgotEmail);
    }

    private submitForgotEmail = (event: any) => {
        this.api.post('/account/resetpassphrase/' + this.state.forgotEmail, {})
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('Password Reset Email Sent', 'success');
                }
            });
        this.setState({
            displayForgotModal: false,
            forgotEmail: '',
        });
    }

    public render() {
        return(
            <div className="Login">
                <header className="Login-header">
                    <img src={this.TenantStore.logoPathNameApp}/>
                </header>
                <Message messages={this.MessageStore.messages} />
                <div className="Login-content">
                    <Form>
                        <h1>Login to MudMetrix</h1>
                        <FormGroup>
                            <Label for="username">Email</Label>
                            <Input type="text" id="userName" name="userName" placeholder="Email" value={ this.state.userName } onChange={ this.handleInputChange }/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="password">Password</Label>
                            <Input type="password" id="password" name="password" value={ this.state.password } onChange={ this.handleInputChange }/>
                        </FormGroup>
                        <Button color="primary" onClick={this.handleLogin} type="submit">Login to MudMetrix</Button>
                        <Link to="" onClick={this.toggleForgotModal} className="float-right">Forgot Password?</Link>
                    </Form>
                </div>
                <footer className="Login-footer">
                    <p className="float-left">© MudMetrix, 2020</p>
                    <p className="float-right">Last Updated: {this.state.updateDate} | Version {this.state.updateVersion}</p>
                </footer>
                <Modal toggle={this.toggleForgotModal} isOpen={this.state.displayForgotModal}>
                    <ModalHeader toggle={this.toggleForgotModal}>
                        Forgot Password?
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="forgotEmail">Valid Email Address</Label>
                            <Input
                                type="email"
                                required={true}
                                name="forgotEmail"
                                value={this.state.forgotEmail}
                                onChange={this.updateForgotEmail}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.submitForgotEmail} disabled={!this.isForgotValidEmail()}>Request New Password</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Login/Login.tsx